import storageService from "../util/storage";

const logout = () => {
    console.log('Logging out the user.');
    storageService.removeItem("token");
    storageService.removeItem("bearer");
    storageService.removeItem("user");
    window.location.href = "/login";
}

export const catchAllErrors = (asyncFunc) => async (...args) => {
    try {
        return await asyncFunc(...args);
    } catch (error) {
        if (error.networkError && error.networkError.statusCode === 401) {
            console.error('Unauthorized: Logging out the user.');
            logout()
        } else {
            // console.error('An error occurred:', error);
            // Handle other errors
        }
        // throw error; // Re-throw the error if needed
    }
};